// removed by extract-text-webpack-plugin
module.exports = {"mb-container":"index__mb-container--2eOVb","mb-iframe":"index__mb-iframe--2JjSz"};


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/machine-box/components/styles/index.scss
// module id = hOp6
// module chunks = 23